module.exports = __webpack_public_path__ + "img/vertical_7_5_3016.902a454e.png";